<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Meus Horários
          <e-help-tooltip :text="$constants.tooltips.horariosInstrutores.meusHorarios" />
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text class="horarios-page__content">
            <horario-tabs v-model="tab" class="horarios-page__tabs" />

            <section v-if="tab === 0" class="horarios-page__section">
              <horario-dia-filtro
                v-model="dataSelecionada"
                class="horarios-page__filter"
                @buscar="buscarDia"
              />

              <horario-lista-agrupada :registros="registrosDia" />
            </section>

            <section v-if="tab === 1" class="horarios-page__section">
              <v-btn color="primary" class="horarios-page__action" @click="buscarUltimos10Dias">
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
              <horario-lista-agrupada :registros="registrosUltimos10Dias" />
            </section>

            <section v-if="tab === 2" class="horarios-page__section">
              <horario-periodo-filtro
                class="horarios-page__filter"
                @buscar="buscarPeriodo"
                @gerar-pdf="gerarPdfPeriodo"
              />
              <horario-lista-agrupada
                :registros="registrosPeriodo"
                :consulta-iniciada="consultaPeriodoIniciada"
              />
            </section>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <e-modal-espelho-ponto-pdf
      :dialog="dialogPdf"
      :pdf="pdf"
      title="Espelho de Ponto"
      @close="fecharPdf"
    />
  </main-template>
</template>

<script>
import EModalEspelhoPontoPdf from "@/components/Instrutores/EModalEspelhoPontoPdf.vue";
import HorarioDiaFiltro from "@/components/Instrutores/HorarioDiaFiltro.vue";
import HorarioListaAgrupada from "@/components/Instrutores/HorarioListaAgrupada.vue";
import HorarioPeriodoFiltro from "@/components/Instrutores/HorarioPeriodoFiltro.vue";
import HorarioTabs from "@/components/Instrutores/HorarioTabs.vue";

export default {
  name: "MeusHorariosPage",
  components: {
    EModalEspelhoPontoPdf,
    HorarioDiaFiltro,
    HorarioListaAgrupada,
    HorarioPeriodoFiltro,
    HorarioTabs,
  },
  data() {
    return {
      tab: 0,
      dataSelecionada: new Date().toISOString().slice(0, 10),
      registrosDia: null,
      registrosUltimos10Dias: null,
      registrosPeriodo: null,
      consultaPeriodoIniciada: false,
      dialogPdf: false,
      pdf: null,
    };
  },
  watch: {
    tab(value) {
      if (value === 1 && Object.keys(this.registrosUltimos10Dias).length === 0) {
        this.buscarUltimos10Dias();
      }
    },
  },
  mounted() {
    this.buscarDia();
    this.buscarUltimos10Dias();
  },
  methods: {
    async buscarDia() {
      try {
        this.$loaderService.open("Carregando horários");
        this.registrosDia = await this.$services.instrutorHorariosService.meusHorariosDia({
          data: this.dataSelecionada,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarUltimos10Dias() {
      try {
        this.registrosUltimos10Dias =
          await this.$services.instrutorHorariosService.meusHorariosUltimos10Dias();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async buscarPeriodo(form) {
      if (!form?.data_inicio || !form?.data_fim) return;
      if (form.data_fim < form.data_inicio) return;

      try {
        this.consultaPeriodoIniciada = true;
        this.$loaderService.open("Carregando período");
        this.registrosPeriodo = await this.$services.instrutorHorariosService.meusHorariosPeriodo(
          form
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarPdfPeriodo(form) {
      if (!form?.data_inicio || !form?.data_fim) return;
      if (form.data_fim < form.data_inicio) return;

      try {
        this.$loaderService.open("Gerando espelho de ponto");
        this.limparPdfAtual();
        this.pdf = await this.$services.instrutorHorariosService.meusHorariosPeriodoPdf(form);
        this.dialogPdf = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fecharPdf() {
      this.dialogPdf = false;
      this.limparPdfAtual();
    },
    limparPdfAtual() {
      if (this.pdf) {
        window.URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.horarios-page__content {
  padding: 24px;
}

.horarios-page__tabs {
  margin-top: 4px;
}

.horarios-page__section {
  margin-top: 20px;
}

.horarios-page__filter,
.horarios-page__action {
  margin-bottom: 20px;
}

@media (max-width: 959px) {
  .horarios-page__content {
    padding: 20px;
  }
}
</style>
